import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { getUrlExtension, setDocTitle } from "../../../functions/HelperFuncs";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      homePage: "spaces",
      company: this.$store.state.company,
      home_logo: "",
      home_screen: "",
      name: "",
      error: "",
      linksend: false,
      imageStyle: { opacity: 0 },
      imageStyleLogo: { opacity: 0 },
      imageStyleLogo2: { opacity: 0 },
      forms: [
        { id: "login", label: "Enter your credentials" },
        { id: "passwordReset", label: "Forgot password" },
        { id: "usernameReset", label: "Forgot username" },
      ],
      activeFormIndex: 0,
    };
  },
  beforeMount() {
    //check if mobile
    this.redirect();
  },
  created() {
    setDocTitle("login", this);

    if (this.$store.state.user) {
      //user is logged in so redirect to home page
      this.$router.push(`/${this.$store.state.company}/${this.homePage}`);
    }

    EventBus.$on("loginSubmit", (data) => {
      if (this.checkIfForHere(data.id)) {
        this.submit();
      }
    });

    EventBus.$on("backToLogin", (data) => {
      if (this.checkIfForHere(data.id)) {
        this.switchForms("login");
      }
    });

    EventBus.$on("forgotPassword", (data) => {
      if (this.checkIfForHere(data.id)) {
        this.switchForms("passwordReset");
      }
    });

    EventBus.$on("passwordReset", (data) => {
      if (this.checkIfForHere(data.id)) {
        this.passwordReset();
      }
    });

    EventBus.$on("usernameReset", (data) => {
      if (this.checkIfForHere(data.id)) {
        this.sendUsernames();
      }
    });
  },
  mounted() {
    this.$axios.get(baseUrl + "/company").then((response) => {
      this.home_logo = response.data.home_logo;
      this.name = response.data.display_name;
      this.home_screen = response.data.home_screen;
    });
  },
  methods: {
    checkIfForHere(name) {
      return name === "mobile-login";
    },
    switchForms(formName) {
      this.activeFormIndex = this.forms
        .map((form) => form.id)
        .indexOf(formName);

      //reset error

      this.error = "";
      this.linksend = false;
    },
    submit() {
      const formData = new FormData(this.$refs.loginForm);

      this.$axios
        .post(baseUrl + "/login", formData)
        .then((response) => {
          if (response.data) {
            const user = response.data;
            this.$store.state.user = response.data;
            this.$axios.defaults.params["key"] = response.data.key;
            localStorage.setItem(
              this.$store.state.company + "_" + "user",
              JSON.stringify(response.data)
            );

            this.$axios
              .get(baseUrl + "/role?id=" + (user ? user.role_id : null))
              .then((response) => {
                this.$store.state.role = response.data.role;
              });

            //go to the spaces page (home)
            this.$router.push(`/${this.$store.state.company}/${this.homePage}`);
          } else {
            this.error = "Your credentials do not match our records.";
          }
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            this.error = "Something went wrong.";
          } else {
            this.error = "Something went wrong.";
          }
        });
    },
    passwordReset() {
      const formData = new FormData(this.$refs.loginForm);

      this.$axios
        .post(baseUrl + "/passwordreset", formData)
        .then((response) => {
          if (response.data) {
            this.error = "";
            this.linksend = true;
          } else {
            this.error = "This user is unkown to us.";
            this.linksend = false;
          }
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            this.error = "Something went wrong.";
          } else {
            this.error = "Something went wrong.";
          }
        });
    },
    sendUsernames() {
      const formData = new FormData(this.$refs.loginForm);

      this.$axios
        .post(baseUrl + "/usernameforget", formData)
        .then((response) => {
          if (response.data) {
            this.error = "";
            this.linksend = true;
          } else {
            this.error = i18n.t("upload.email_unknown");
            this.linksend = false;
          }
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            this.error = i18n.t("common.something_went_wrong");
          } else {
            this.error = i18n.t("common.something_went_wrong");
          }
          this.linksend = false;
        });
    },
    imageLoaded(event) {
      this.imageStyle = { opacity: 1 };
    },
    imageLoadedLogo(event) {
      this.imageStyleLogo = { opacity: 1 };
    },
    imageLoadedLogo2(event) {
      this.imageStyleLogo2 = { opacity: 1 };
    },
    openLoginScreen(variable) {
      setTimeout(
        () => {
          this.loginScreenIsOpen = variable;
        },
        !variable ? 400 : 0
      );
    },
    redirect() {
      if (!this.$store.state.isMobile) {
        //is desktop so go to collections
        this.$router.replace(`/${this.$store.state.company}`);
      }
    },
  },
  computed: {
    hasBrandVideo() {
      if (this.home_screen) {
        if (getUrlExtension(this.home_screen) === "mp4") {
          return true;
        }
      }
      return false;
    },
  },
};
